import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import ProtectedRoute from "./components/ProtectedRoute";
import { AuthProvider } from "./context/AuthContext";
import Landing from "./pages/Landing";
import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import UserManagement from "./pages/UserManagement";
import TeamManagement from "./pages/TeamManagement";
import EvaluationCriteria from "./pages/EvaluationCriteria";
import EvaluationPeriodManagement from "./pages/EvaluationPeriodManagement";
import EvaluationSubmission from "./pages/EvaluationSubmission";
import EvaluationList from "./pages/EvaluationList";
import EvaluationForm from "./pages/EvaluationForm";
import EvaluationReport from "./pages/EvaluationReport";
import TeamEvaluation from "./pages/TeamEvaluation";
import TeamEvaluationForm from "./pages/TeamEvaluationForm";
import TeamEvaluationList from "./pages/TeamEvaluationList";
import TeamEvaluationReport from "./pages/TeamEvaluationReport";
import NotificationManagement from "./pages/NotificationManagement";
import AiSummary from "./pages/AiSummary";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route element={<Layout />}>
            <Route index element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/users"
              element={
                <ProtectedRoute roles={["ADMIN"]}>
                  <UserManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/teams"
              element={
                <ProtectedRoute roles={["ADMIN"]}>
                  <TeamManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/evaluation-criteria"
              element={
                <ProtectedRoute roles={["ADMIN"]}>
                  <EvaluationCriteria />
                </ProtectedRoute>
              }
            />
            <Route
              path="/evaluation-periods"
              element={
                <ProtectedRoute roles={["ADMIN"]}>
                  <EvaluationPeriodManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/evaluations/new"
              element={
                <ProtectedRoute roles={["ADMIN", "MANAGER", "EMPLOYEE"]}>
                  <EvaluationSubmission />
                </ProtectedRoute>
              }
            />
            <Route
              path="/evaluations"
              element={
                <ProtectedRoute>
                  <EvaluationList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/evaluations/:id/report"
              element={
                <ProtectedRoute>
                  <EvaluationReport />
                </ProtectedRoute>
              }
            />
            <Route
              path="/evaluations/form"
              element={
                <ProtectedRoute roles={["ADMIN", "MANAGER"]}>
                  <EvaluationForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="/team-evaluations/new"
              element={
                <ProtectedRoute roles={["ADMIN", "MANAGER"]}>
                  <TeamEvaluationForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="/team-evaluations"
              element={
                <ProtectedRoute roles={["ADMIN", "MANAGER"]}>
                  <TeamEvaluationList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/team-evaluations/:id/report"
              element={
                <ProtectedRoute roles={["ADMIN", "MANAGER"]}>
                  <TeamEvaluationReport />
                </ProtectedRoute>
              }
            />
            <Route
              path="/team-evaluations/old"
              element={
                <ProtectedRoute roles={["ADMIN", "MANAGER"]}>
                  <TeamEvaluation />
                </ProtectedRoute>
              }
            />
            <Route
              path="/notifications"
              element={
                <ProtectedRoute roles={["ADMIN", "MANAGER"]}>
                  <NotificationManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ai/insights"
              element={
                <ProtectedRoute>
                  <AiSummary />
                </ProtectedRoute>
              }
            />
          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
